import React from 'react';
import { ClipLoader } from 'react-spinners';
import './skiold-icon-spinner.scss';
import { ViewWeb } from 'web/view/components/utils/web-view';
import { SkioldTouchableOpacity } from '../skiold-components/skiold-touchable-opacity';
import { SkioldImage } from './svg/skiold-image';
import { WhiteText } from '../Text/white-text';
import { localizedDynamic } from 'shared/state/i18n/i18n';
interface SkioldIconSpinnerProps {
	title: string;
	icon: any;
	itemFromParent?: any;
	onPress: (itemFromParent?: any) => void;
	containerClassName?: any;
	showSpinner?: boolean;
	showSpinnerControlled?: boolean;
	clipSize?: number;
	width?: number;
	height?: number;
}

interface State {
	showSpinner: boolean;
}

export class SkioldIconSpinner extends React.PureComponent<SkioldIconSpinnerProps, State> {
	public static defaultProps: Partial<SkioldIconSpinnerProps> = {
		containerClassName: '',
		clipSize: 35,
		width: 60,
		height: 60,
	};
	constructor(props: SkioldIconSpinnerProps) {
		super(props);
		this.state = {
			showSpinner: false,
		};
	}

	public render() {
		return (
			<ViewWeb className={`skiold-icon-spinner ${this.props.containerClassName}`}>
				<ViewWeb className="image-container">
					<SkioldTouchableOpacity className="image-container" onPress={this.handleSpinner}>
						<SkioldImage width={this.props.width} height={this.props.height} imageData={this.props.icon} />
					</SkioldTouchableOpacity>
					{this.state.showSpinner || this.props.showSpinner || this.props.showSpinnerControlled ? (
						<ViewWeb
							className="spinner-container-active"
							style={{ width: this.props.width, height: this.props.height }}
						>
							<ClipLoader color="#f2ac40" size={this.props.clipSize} />
						</ViewWeb>
					) : (
						<ViewWeb className="spinner-container-disabled" />
					)}
				</ViewWeb>
				<WhiteText>{localizedDynamic(this.props.title)}</WhiteText>
			</ViewWeb>
		);
	}

	private handleSpinner = async () => {
		this.setState({ showSpinner: true });
		await this.props.onPress(this.props.itemFromParent);
		this.setState({ showSpinner: false });
	};
}
